import { environment } from '../../../../environments/environment.prod';

export let baseUrl = environment.apiBase;

export const loginUrl = baseUrl + '/api/login';
export const logoutUrl = baseUrl + '/api/logout';
export const registerUrl = baseUrl + '/api/register';
export const tokenRefresh = baseUrl + '/api/login/refresh';
export const changePasswordUrl = baseUrl + '/api/change-password';
export const requestPasswordUrl = baseUrl + '/api/request?';
export const resetPasswordUrl = baseUrl + '/api/reset';
export const travelAuthorUrlOld = baseUrl + '/api/requestor/travel-authorization';
export const travelSummaryUrl = baseUrl + '/api/requestor/travel-summary-detail';
export const travelBookingUrl = baseUrl + '/api/requestor/travel-booking-detail';
export const travelCashApproverUrl = baseUrl + '/api/approver/cash-advance';
export const reimbursementDetailUrl = baseUrl + '/api/requestor/reimbursement-detail';
export const liquidationDetailUrl = baseUrl + '/api/requestor/liquidation-detail';
export const countryUrl = baseUrl + '/api/country';
export const provinceUrl = baseUrl + '/api/province';
export const barangayUrl = baseUrl + '/api/barangay';
export const vatUrl = baseUrl + '/api/vat';
export const cityUrl = baseUrl + '/api/city';
export const miscellaneousUrl = baseUrl + '/api/miscellaneous';
export const departmentUrl = baseUrl + '/api/requestor/department';
export const positionUrl = baseUrl + '/api/requestor/position';
export const statusUrl = baseUrl + '/api/approver/status-summary';
export const employeeTransactionUrl = baseUrl + '/api/approver/employee/transaction';
export const dashboardApprover = baseUrl + '/api/approver/dashboard';
export const dashboardRequestor = baseUrl + '/api/requestor/dashboard';
export const agingEmployeeUrl = baseUrl + '/api/approver/unliquidated/per-employee';
export const agingDeparmentUrl = baseUrl + '/api/approver/unliquidated/per-department';
export const countMaxUrl = baseUrl + '/api/requestor/count-system';

// Version 1.5
export const employeeListUrl = baseUrl + '/api/v1/employee-masterlist';
export const supplierUrl = baseUrl + '/api/v1/supplier';

// Requestor
export const travelRequestUrl = baseUrl + '/api/v1/requestor/travel-request';
export const travelItineraryUrl = baseUrl + '/api/v1/requestor/travel-itinerary';
export const travelAuthorUrl = baseUrl + '/api/v1/requestor/travel-request';
export const liquidationUrl = baseUrl + '/api/v1/requestor/liquidation';
export const travelCashUrl = baseUrl + '/api/v1/requestor/cash-advance';
export const itineraryLQUrl = baseUrl + '/api/v1/requestor/itinerary-liquidation';
export const itineraryDeleteUrl = baseUrl + '/api/v1/requestor/itinerary-liquidation-delete';
export const reimbursementUrl = baseUrl + '/api/v1/requestor/reimbursement';
export const itineraryRBUrl = baseUrl + '/api/v1/requestor/itinerary-reimbursement';
export const itineraryDeleteRBUrl = baseUrl + '/api/v1/requestor/itinerary-reimbursement-delete';
export const itineraryDeleteBookingUrl = baseUrl + '/api/v1/requestor/itinerary-booking';

// Approver
export const travelApproveUrl = baseUrl + '/api/v1/approver/travel-request';
export const liquidationApproverUrl = baseUrl + '/api/v1/approver/liquidation';
export const reimbursementApproverUrl = baseUrl + '/api/v1/approver/reimbursement';

export const moduleRequestor = [
    {
        name: 'Travel Request',
        url: '/travel-request'
    },
    {
        name: 'Liquidation',
        url: '/liquidation'
    },
    {
        name: 'Reimbursement',
        url: '/reimbursement'
    }
];

export const moduleApprover = [
    {
        name: 'Travel Request Approver',
        url: '/travel-request-approver'
    },
    {
        name: 'Liquidation Approver',
        url: '/liquidation-approver'
    },
    {
        name: 'Reimbursement Approver',
        url: '/reimbursement-approver'
    },
    {
        name: 'Employee Transaction Summary',
        url: '/employee-transaction'
    },
    {
        name: 'Status Summary',
        url: '/status-summary'
    },
    {
        name: 'Per Department Summary',
        url: '/per-department-summary'
    },
    {
        name: 'Aging of Unliquidated CA Per Employee',
        url: '/aging-per-employee'
    },
    {
        name: 'Aging of Unliquidated CA Per Department',
        url: '/aging-per-deparment'
    }
];


export const TRAVELTYPE = ["Cash Advance","Reimbursement"];
export const BOOKINGTYPE = ["Self","Office"];
export const BOOKINGMETHOD = ["Book and Pay","Book Only"];
export const TRANSPORTATION = ["Airplane","Ferry","Boat","Bus","Van","Taxi","Jeepney","Tricycle","Motorcycle","LRT","MRT","PNR","Bicycles with Sidecar","None"].sort();
export const SPECIAL_TRANSPORTATION = ["Airplane","Ferry", "None"];
export const AIRLINES = ["CEBU PACIFIC","PHILIPPINE AIRLINES","AIR ASIA","SKYJET","CATHAY PACIFIC AIRWAYS","OTHERS"].sort();
export const PURPOSE = ["STORE OPENING", "STORE CLOSURE", "STORE VISIT", "AUDIT", "INVENTORY COUNT", "ASSET COUNT", "TEMPORARY ASSIGNMENT", "OTHERS"].sort();